module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "equipment-option"
    }
  }, [_c('h4', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.isTenG ? '10Gbps connections include XWi' : 'Add premium home WiFi'))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [(!_vm.activeRouterAvailable) ? _c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xwi-oos"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0)]) : _c('label', {
    staticClass: "mb-3",
    on: {
      "click": function($event) {
        return _vm.setNeedsRouter(true)
      }
    }
  }, [_c('input', {
    class: _vm.isTenGRouter ? 'xwi-xtndrs' : '',
    attrs: {
      "type": "radio",
      "name": _vm.isTenG ? 'xtndrs' : 'xwi',
      "id": "xwi-radio"
    },
    domProps: {
      "checked": _vm.isTenG
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xwi"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('img', {
    class: _vm.isTenGRouter ? '' : 'd-none d-md-block',
    style: (_vm.isTenGRouter ? 'margin:0 -30px 0 10px' : 'margin-right:-30px'),
    attrs: {
      "src": _vm.routerImageLink,
      "height": "200"
    }
  })]), _vm._v(" "), _c('td', {
    class: _vm.isTenGRouter ? 'pr-3 pl-3 pb-3 w-100' : 'pr-3 pl-3 w-100'
  }, [(_vm.grossMonthlyRateReady) ? _c('div', {
    attrs: {
      "id": "get-xwi-headline"
    }
  }, [_c('strong', {
    staticClass: "mb-1"
  }, [_vm._v("Total home Internet solution")]), _vm._v(" "), (!_vm.isTenG) ? _c('center', [_c('b', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.grossMonthlyRate))]), _vm._v("/mo")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.isTenGRouter ? 'w-100' : '',
    attrs: {
      "id": "xwi-benys"
    }
  }, [_c('b', [_vm._v("Control your home WiFi with ease")]), _vm._v(" "), (!_vm.isTenGRouter) ? _c('ul', [_c('li', [_vm._v("XWi 1Gbps WAN WiFi 6 Router (4x1Gbps LAN) and app")]), _vm._v(" "), _c('li', [_vm._v("Remote XMission support for hassle-free maintenance")]), _vm._v(" "), _c('li', [_vm._v("Up to 250 devices with 2,500 sq ft coverage")]), _vm._v(" "), _c('li', [_vm._v("Powerful parental controls and protection from malware and viruses")])]) : _c('ul', [_c('li', [_vm._v("XWi Premium WiFi 6e router and app")]), _vm._v(" "), _c('li', [_vm._v("Remote XMission support for hassle-free maintenance")]), _vm._v(" "), _c('li', [_vm._v("Powerful parental controls and protection from malware and viruses")]), _vm._v(" "), _c('li', [_vm._v("Up to 250 devices with 2,500 sq ft coverage")])]), _vm._v(" "), (_vm.isTenGRouter) ? _c('a', {
    staticClass: "btn btn-info btn-sm float-right",
    attrs: {
      "href": "https://xmission.com/xwi",
      "target": "_blank"
    }
  }, [_vm._v("Learn more")]) : _vm._e()]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])])])])])]), _vm._v(" "), (!_vm.isTenG) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', {
    staticClass: "mb-3",
    on: {
      "click": function($event) {
        return _vm.setNeedsRouter(false)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "xwi",
      "id": "none-radio"
    }
  }), _vm._v(" "), _vm._m(1)])]) : _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', {
    on: {
      "click": function($event) {
        return _vm.setNeedsRouter(false)
      }
    }
  }, [_c('input', {
    staticClass: "xwi-xtndrs",
    attrs: {
      "type": "radio",
      "name": "xtndrs",
      "id": "none-radio"
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), (_vm.isTenG) ? _c('button', {
    staticClass: "btn btn-outline-dark",
    on: {
      "click": function($event) {
        _vm.ten_g_button_clicked = true
      }
    }
  }, [_vm._v("OK, proceed")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('mesh-extender')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routerSelected && _vm.needsRouter && _vm.activeRouterAvailable),
      expression: "routerSelected && needsRouter && activeRouterAvailable"
    }],
    staticClass: "mt-3",
    attrs: {
      "id": "mesh-extender"
    }
  }, [_c('h4', {
    staticClass: "mt-2"
  }, [_vm._v("Extend your WiFi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [(!_vm.meshesAvailable) ? _c('div', {
    staticClass: "mb-3 w-100"
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xtndr-oos"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_c('img', {
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-logo-black.png",
      "alt": "xwi"
    }
  }), _vm._v(" Mesh Extender")]), _vm._v(" "), _c('table', [_c('tr', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('img', {
    staticClass: "mt-4",
    staticStyle: {
      "filter": "grayscale(100%)",
      "opacity": "0.5"
    },
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-mesh-extender.png",
      "width": "140"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "pr-3 pl-3 w-100"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("Temporarily Out of Stock")]), _vm._v("\n                    New mesh extenders arriving soon. "), _c('br'), _vm._v("Please\n                    "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "tel:8015390852"
    }
  }, [_c('b', [_vm._v("call (801) 539-0852")])]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "https://chat.xmission.com",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("chat")])]), _vm._v(" for exact date.\n                    "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])])])])]) : _c('label', {
    staticClass: "mb-3 w-100"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "xtndr",
      "id": "xtndr-radio"
    },
    domProps: {
      "checked": _vm.meshExtendersSelected && _vm.isMeshLease
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xtndr"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_c('img', {
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-logo-black.png",
      "alt": "xwi"
    }
  }), _vm._v(" Mesh Extender")]), _vm._v(" "), _c('table', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('img', {
    staticClass: "mt-4",
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-mesh-extender.png",
      "width": "140"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "pr-3 pl-3 w-100"
  }, [_c('div', [_c('b', [_vm._v("Increase WiFi range from router to device")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Recommended for homes over 2,500 sq. ft.")]), _vm._v(" "), _c('li', [_vm._v("Extend WiFi 6 coverage for harder to reach areas")]), _vm._v(" "), _c('li', [_vm._v("Add one or more, as needed")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pr-3 pl-3 pb-3"
  }, [_vm._v("\n                    Quantity:\n                    "), _c('select', {
    staticClass: "form-control d-inline",
    attrs: {
      "name": "xtndr-qty",
      "id": "xtndr-qty"
    },
    domProps: {
      "value": _vm.meshQuantityDisplay
    },
    on: {
      "change": _vm.setMeshQuantity
    }
  }, _vm._l((_vm.meshQuantitiesAvailable), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }), 0)]), _vm._v(" "), _c('td', {
    staticClass: "pl-3"
  }, [_c('div', {
    staticClass: "faded",
    attrs: {
      "id": "get-xtndr-price"
    }
  }, [_c('b', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.meshMonthlyRate))]), _vm._v("/mo "), _c('span', {
    staticClass: "each"
  }, [_vm._v("each")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', {
    staticClass: "mb-3"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "xtndr",
      "id": "no-xtndr-radio"
    },
    domProps: {
      "checked": _vm.isMeshNone
    },
    on: {
      "click": _vm.setMeshNone
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "no-xtndr"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("No thanks")]), _vm._v(" "), _c('div', [_vm._v("I don't need mesh extenders.")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('img', {
    staticClass: "ml-2 mb-2 mr-2",
    staticStyle: {
      "filter": "grayscale(100%)",
      "opacity": "0.5"
    },
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-router-app.png",
      "height": "100"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "pr-3 pl-3 w-100"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("Temporarily Out of Stock")]), _vm._v("\n                New routers arriving soon. "), _c('br'), _vm._v("Please\n                "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "tel:8015390852"
    }
  }, [_c('b', [_vm._v("call (801) 539-0852")])]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "https://chat.xmission.com",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("chat")])]), _vm._v(" for exact date.\n                "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "get-nothing"
    }
  }, [_c('h4', [_vm._v("No thanks")]), _vm._v(" "), _c('div', [_vm._v("I will provide my own router")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "get-nothing"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Opt out")]), _vm._v(" "), _c('div', [_vm._v("I will provide my own router")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35908d68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/create/XWiService.vue
// module id = 1315
// module chunks = 16